<div class="relative mt-1 block w-full">
  <input type="text"
    [value]="fileNames.length > 0 ? fileNames.length + ' file' + (fileNames.length > 1 ? 's' : '') + ' selected' : ''"
    [disabled]="disabled"
    class="pl-3 pr-10 py-2 w-full text-base border border-gray-300 bg-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
    placeholder="No file selected" readonly>
  <button type="button" [disabled]="disabled || !canAddMoreFiles"
    class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-500 bg-black text-white rounded-md m-1 disabled:opacity-50"
    (click)="fileInput.click()">
    {{ field.metadata.useMultipleFileUpload ? 'Add Files' : 'Upload File' }}
  </button>
  <input type="file" #fileInput class="hidden" (change)="fileChange($event)" [attr.accept]="extensions.join(',')"
    [multiple]="field.metadata.useMultipleFileUpload" hidden>
</div>


<div *ngIf="fileNames.length > 0" class="mt-2">
  <div *ngFor="let fileName of fileNames; let i = index"
    class="flex justify-between items-center py-1 px-2 bg-gray-50 rounded mb-1">
    <span class="text-sm text-gray-600 truncate">{{ fileName }}</span>
    <button type="button" (click)="removeFile(i)" class="ml-2 text-red-500 hover:text-red-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</div>

<div class="flex flex-row justify-between px-1">
  <div class="text-xs text-gray-500 mt-1">
    Accepted extensions: {{ extensions.join(', ') }}
  </div>
  <div class="flex flex-col items-end">
    <div class="text-xs text-gray-500 mt-1">
      Max file size: {{fileUploadLimit}} MB
    </div>
    <div *ngIf="field.metadata.useMultipleFileUpload && multipleFileUploadLimit !== null"
      class="text-xs text-gray-500 mt-1">
      Max files: {{ multipleFileUploadLimit }}
    </div>
  </div>
</div>